import type { ReactNode } from 'react';

export const symbol_sdk: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-535q0-9.8 3.5-18.55T134-750l57-74q6.46-8 14.71-12t18.29-4h513q10.04 0 18.29 4T770-824l57 74q5 8 9 16.65 4 8.66 4 18.35v535q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm18-615h565l-36.41-45H234l-36 45Zm-18 555h600v-495H180v495Zm460-247-70 70q-8 8.35-8 20.17 0 11.83 8 19.83 8 8 19.83 8 11.82 0 20.17-8l89-89q9-9 9-21t-9-21l-89-89q-8.35-8-20.17-8-11.83 0-19.83 8-8 8-8 19.83 0 11.82 8 20.17l70 70Zm-320 4 70-70q8-8.35 8-20.17 0-11.83-8-19.83-8-8-19.83-8-11.82 0-20.17 8l-89 89q-9 9-9 21t9 21l89 89q8.35 8 20.17 8 11.83 0 19.83-8 8-8 8-19.83 0-11.82-8-20.17l-70-70ZM180-180v-495 495Z"
		/>
	</svg>
);
